import preset from "../preset";

export const bgClass = preset.pclasses('bg');

export default bgClass;
